import {mapState} from 'vuex';

export default {
  computed: {
    ...mapState({
      account: state => state.frontend.auth.user,
    })
  }
}
